module.exports = __webpack_public_path__ + "static/img/thumb_27.bc50fc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_27.png
// module id = OoQj
// module chunks = 0